module.exports = __webpack_public_path__ + "media/images/steps/svg/277-promotion-4a07cfcb06fa4b5d298a124a820dd7e3.svg";